export const sheetKey = (ids) => ids.split(',').map(x => x.trim().toLowerCase()).filter(Boolean).sort().join(',');
export const registeredHoursLabel = (hours, conflict) => conflict ? 'Needs review' : typeof hours === 'number' && Number.isSafeInteger(hours) && hours >= 0 ? String(hours) : '—';
export function validateHoursDetail(detail, requestedIds) {
    if (!detail || sheetKey(detail.timeSheetIds || '') !== sheetKey(requestedIds) ||
        !Number.isSafeInteger(detail.totalHours) || detail.totalHours < 0 || !Array.isArray(detail.rows))
        throw new Error('The hours response is incomplete. Refresh the list.');
    const seen = new Set();
    let total = 0;
    for (const row of detail.rows) {
        if (!row.id || seen.has(row.id) || !Number.isSafeInteger(row.hours) || row.hours < 0 ||
            typeof row.countsTowardsTotal !== 'boolean' || !Number.isFinite(Date.parse(row.date)))
            throw new Error('The hours response contains inconsistent data.');
        seen.add(row.id);
        if (row.countsTowardsTotal)
            total += row.hours;
    }
    if (total !== detail.totalHours)
        throw new Error('The hours total could not be verified. Refresh the list.');
    return detail;
}
export function sumRegisteredHours(sheets) {
    let total = 0;
    for (const sheet of sheets)
        for (const week of sheet.weeklyHourRegistrations)
            for (const hour of week.hourRegistrations) {
                if (typeof hour.countsTowardsTotal !== 'boolean' || !Number.isSafeInteger(hour.noOfHours) || hour.noOfHours < 0)
                    return null;
                if (hour.countsTowardsTotal)
                    total += hour.noOfHours;
            }
    return Number.isSafeInteger(total) ? total : null;
}
